import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as d3 from 'd3';
import { Alert } from 'react-bootstrap';

class ChartComponent extends Component {
  state = {
    invalidAttribute: false
  };

  componentDidMount() {
    const { data } = this.getData();
    this.drawChart(data);
  }

  componentDidUpdate(prevProps, prevState) {
    const { invalidAttribute: prevInvalidAttribute } = prevState;

    const { data, invalidAttribute } = this.getData();
    if (prevInvalidAttribute !== invalidAttribute) this.changeInvalidAttribute(invalidAttribute);

    this.deleteChart();
    this.drawChart(data);
  }

  changeInvalidAttribute = newInvalidAttribute =>
    this.setState({ invalidAttribute: newInvalidAttribute });

  deleteChart = () => {
    d3.selectAll(`.${this.id}`).remove();
  };

  drawChart = () => {};

  getData = () => ({ data: {}, invalidAttribute: false });

  render() {
    const { height, width } = this.props;
    const { invalidAttribute } = this.state;
    if (invalidAttribute)
      return <Alert variant="warning">One of the attributes you selected is invalid</Alert>;
    return <svg id={`svg-${this.id}`} width={width} height={height} />;
  }
}

ChartComponent.defaultProps = {
  height: 0,
  width: 0
};

ChartComponent.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};

export default ChartComponent;
